import { FileRepository } from '@ckeditor/ckeditor5-upload';
import { Command } from '@ckeditor/ckeditor5-core';
import { toArray } from '@ckeditor/ckeditor5-utils';
export default class UploadVideoCommand extends Command {
    /**
     * @inheritDoc
     */
    refresh() {
        const editor = this.editor;
        const videoUtils = editor.plugins.get('VideoUtils');
        const selectedElement = editor.model.document.selection.getSelectedElement();
        this.isEnabled = videoUtils.isVideoAllowed() || videoUtils.isVideo(selectedElement);
    }
    execute(options) {
        const files = toArray(options.files);
        const selection = this.editor.model.document.selection;
        const videoUtils = this.editor.plugins.get('VideoUtils');
        const selectionAttributes = Object.fromEntries(selection.getAttributes());
        // if (!options.file && !options.files) {
        //     return;
        // }
        files.forEach((file, index) => {
            const selectedElement = selection.getSelectedElement();
            if (index && selectedElement && videoUtils.isVideo(selectedElement)) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                this._uploadVideo(file, selectionAttributes, position);
            }
            else {
                this._uploadVideo(file, selectionAttributes);
            }
        });
    }
    _uploadVideo(file, attributes, position) {
        const editor = this.editor;
        const fileRepository = editor.plugins.get(FileRepository);
        const loader = fileRepository.createLoader(file);
        const videoUtils = editor.plugins.get('VideoUtils');
        if (!loader) {
            return;
        }
        videoUtils.insertVideo({ ...attributes, uploadId: loader.id }, position);
    }
}
//# sourceMappingURL=uploadvideocommand.js.map